export default {"src":"/_next/static/media/blues-brandmark-white.38fdb686.svg","height":1360,"width":1354,"blurWidth":0,"blurHeight":0};